import { IsRelativePathSegment } from './segment';
import { PathSegmentsPush } from './mutate';
import { IsAbsolutePathSegments } from './infos';
import { GetProcessPathSegments } from './others';
export function JoinPathSegments(paths, options) {
    const pathsLength = paths.length;
    if (pathsLength === 0) {
        throw new Error(`Expected at least one path`);
    }
    else {
        const joined = paths[0].slice();
        for (let i = 1; i < pathsLength; i++) {
            const path = paths[i];
            let j = 0;
            if (IsAbsolutePathSegments(path, options) && (i > 0)) {
                if ((options.strict === void 0) || options.strict) {
                    throw new Error('Only the first path can be absolute.');
                }
                else {
                    j = 1;
                }
            }
            for (const l = path.length; j < l; j++) {
                PathSegmentsPush(joined, path[j], options);
            }
        }
        return joined;
    }
}
export function CommonBasePathSegments(paths) {
    const pathsLength = paths.length;
    if (pathsLength === 0) {
        throw new Error(`Expected at least one path`);
    }
    else {
        if (pathsLength === 1) {
            return paths[0].slice();
        }
        else {
            const commonBase = [];
            let segment;
            let path;
            let commonBaseLength;
            while (true) {
                commonBaseLength = commonBase.length;
                path = paths[0];
                segment = path[commonBaseLength];
                for (let i = 1; i < pathsLength; i++) {
                    path = paths[i];
                    if ((path.length <= commonBaseLength)
                        || (path[commonBaseLength] !== segment)) {
                        return (commonBaseLength === 0)
                            ? null
                            : commonBase;
                    }
                }
                commonBase.push(segment);
            }
        }
    }
}
export function RelativePathSegments(from, to, options) {
    const commonBase = CommonBasePathSegments([from, to]);
    if (commonBase === null) {
        return null;
    }
    else {
        const relativePath = ['.'];
        for (let i = commonBase.length, l = from.length; i < l; i++) {
            PathSegmentsPush(relativePath, '..', options);
        }
        for (let i = commonBase.length, l = to.length; i < l; i++) {
            PathSegmentsPush(relativePath, to[i], options);
        }
        return relativePath;
    }
}
export function ResolvePathSegmentsWithOptionalRoot(path, root, options) {
    if (root === void 0) {
        root = GetProcessPathSegments(options);
    }
    if (IsAbsolutePathSegments(root, options)) {
        return ResolvePathSegments(path, root, options);
    }
    else {
        throw new Error(`Argument 'root' is not a valid root`);
    }
}
export function ResolvePathSegments(path, root, options) {
    if (IsRelativePathSegment(path[0])) {
        return JoinPathSegments([root, path], options);
    }
    else {
        return path.slice();
    }
}
//# sourceMappingURL=operations.js.map